import { render, staticRenderFns } from "./POIStatistics.vue?vue&type=template&id=0e50beee"
import script from "./POIStatistics.vue?vue&type=script&lang=js"
export * from "./POIStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports